import * as React from 'react';

import { Flex, Headings, ResponsiveSpacing } from '@foradevelopment/fora-ui';

type IntroTextProps = {
  title?: string;
  children?: React.ReactNode;
  links?: React.ReactElement[];
  marginBottom?: ResponsiveSpacing;
};

export const IntroText = ({ title, children, links, marginBottom }: IntroTextProps) => {
  return (
    <Flex
      flexDirection={['column', 'column', 'row']}
      justifyContent={'space-between'}
      marginBottom={marginBottom ?? [30, 30, 60]}
    >
      <Flex maxWidth={783} flexDirection={'column'} rowGap={20} marginBottom={links ? [30, 30, 0] : 0}>
        {title && <Headings.H2 color="black">{title}</Headings.H2>}
        {children}
      </Flex>
      {links && (
        <Flex
          rowGap={10}
          minWidth={[0, 0, 370]}
          flexDirection={'column'}
          alignItems={['flex-start', 'flex-start', 'flex-end']}
        >
          {links.map((link, key) => React.cloneElement(link, { key: key }))}
        </Flex>
      )}
    </Flex>
  );
};
